import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgEdit = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 40,
	height: 40,
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M0 31.6655V40H8.33449L32.9268 15.4077L24.5923 7.0732L0 31.6655ZM39.3499 8.98458C40.2167 8.11779 40.2167 6.70649 39.3499 5.8397L34.1603 0.65009C33.2935 -0.216697 31.8822 -0.216697 31.0154 0.65009L26.9482 4.71732L35.2827 13.0518L39.3499 8.98458Z",
		fill: "currentColor"
	})
});
export default SvgEdit;
